import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { AuthenticationService } from '../../services/usuario/authentication.service';
import { UtilHelper } from '../../_helpers/util';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: [],
  providers: [AuthenticationService]
})
export class AuthComponent implements OnInit {
  model: any = {};
  uid: string = '';
  sid: string = '';
  servidorPublico: any = [];

  constructor(private route: ActivatedRoute, private _router: Router, private _as: AuthenticationService) {
    this.route.paramMap.subscribe(params => {
      this.uid = (parseInt(params.get('uid')) - 73905).toString();
      this.sid = params.get('sid');
      this.getData(this.uid, this.sid);
    });
  }

  ngOnInit() {
    this._as.logout();
  }

  getData(uid: string, sid: string) {
    this._as.getDataUser(uid, sid)
      .subscribe(items => {
        if (items.status == 'success') {
          this.login(items.cedula, items.cedula);          
          localStorage.setItem('menu', JSON.stringify(items.grupo_menu));
          localStorage.setItem('rol_au', JSON.stringify(items.rol));
        } else {
          this._router.navigate(['/login']);
        }
      },
        error => { console.log("Error al obtener datos del servicio"); }
      );
  }

  login(username: string, password: string) {
    this._as.postLogin({ username: username, password: password }).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          localStorage.setItem('u', JSON.stringify(result.data));
          localStorage.setItem('g', result.data.gestion);
          window.location.href = '/';
        } else {
          this._router.navigate(['/login']);
        }
      },
      error => { console.log('Error', error); });

  }

  valid(user: string, password: string) {
    if (user != password) {
      return false;
    }
    if (password.length < 5) {
      return false;
    }
    return true;
  }
}
